module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start01-0ef4037f05eba9b3cb33bda8b236572d.jpg";